import styles from './GeneralConditionL1.module.css'
import SmallPieGraph from '../../../general/SmallPieGraph'
import Api from '../../../../services/Api'
import Functions from '../../../../services/Functions'
import React, { useEffect, useState } from "react"

function GeneralConditionL1({
  distrito,
  menuFilterParams,
  searchControl,
  generalConditionValues,
  setGeneralConditionsProperties1,
}) {
  const [carroProprio, setCarroProprio] = useState(null);
  const [energiaEletrica, setEnergiaEletrica] = useState(null);
  const [abastecimentoAgua, setAbastecimentoAgua] = useState(null);
  const [carroProprioOldValue, setCarroProprioOldValue] = useState(null);
  const [energiaEletricaOldValue, setEnergiaEletricaOldValue] = useState(null);
  const [abastecimentoAguaOldValue, setAbastecimentoAguaOldValue] =  useState(null);
  const [loading, setLoading] = useState(true);

  const {selectedOption, searchInput } = searchControl;
  const {category, subcategoria, natureza } = menuFilterParams;
  const {carroProprioValue, energiaEletricaValue, abastecimentoAguaValue, tipoFossaValue, descarteLixoValue, descarteEsgotoValue} = generalConditionValues;
  const {setCarroProprioValue, setEnergiaEletricaValue, setAbastecimentoAguaValue, setCarroImage, setEnergiaImage, setAguaImage} = setGeneralConditionsProperties1;

  const inscricao = Functions.getInscricaoParam(selectedOption, searchInput);
  const proprietario = Functions.getProprietarioParam(
    selectedOption,
    searchInput
  );

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [carro, energia, agua] = await Promise.all([
          Api.getPossuiCarro(
            distrito,
            category,
            subcategoria,
            natureza,
            inscricao,
            proprietario,
            energiaEletricaValue,
            abastecimentoAguaValue,
            tipoFossaValue,
            descarteLixoValue,
            descarteEsgotoValue
          ),
          Api.getEnergiaEletrica(
            distrito,
            category,
            subcategoria,
            natureza,
            inscricao,
            proprietario,
            carroProprioValue,
            abastecimentoAguaValue,
            tipoFossaValue,
            descarteLixoValue,
            descarteEsgotoValue
          ),
          Api.getAbastecimentoAgua(
            distrito,
            category,
            subcategoria,
            natureza,
            inscricao,
            proprietario,
            carroProprioValue,
            energiaEletricaValue,
            tipoFossaValue,
            descarteLixoValue,
            descarteEsgotoValue
          ),
        ]);
        setCarroProprio(Functions.buildSmallPieGraphParams(carro));
        setEnergiaEletrica(Functions.buildSmallPieGraphParams(energia));
        setAbastecimentoAgua(Functions.buildSmallPieGraphParams(agua));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprioValue,
    energiaEletricaValue,
    abastecimentoAguaValue,
    tipoFossaValue,
    descarteLixoValue,
    descarteEsgotoValue,
  ]);

  if (loading) return <div className={styles.generalConditionL1}></div>;

  const onEnergiaEletricaClick = (value) => {
    setEnergiaEletricaValue(value);
  };

  const onPossuiCarroClick = (value) => {
    setCarroProprioValue(value);
  };

  const onAbastecimentoAguaClick = (value) => {
    setAbastecimentoAguaValue(value);
  };

  const onEnergiaEletricaOldValue = (value) => {
    setEnergiaEletricaOldValue(value);
  };

  const onPossuiCarroOldValue = (value) => {
    setCarroProprioOldValue(value);
  };

  const onAbastecimentoAguaOldValue = (value) => {
    setAbastecimentoAguaOldValue(value);
  };

  return (
    <div className={styles.generalConditionL1}>
      {carroProprio && (
        <div className={styles.smallPiegraph}>
          <SmallPieGraph
            data={carroProprio}
            text="POSSUI CARRO PRÓPRIO"
            onLegendClick={onPossuiCarroClick}
            currentValue={carroProprioValue}
            oldValue={carroProprioOldValue}
            onOldValue={onPossuiCarroOldValue}
            onImageReady={setCarroImage}
          />
        </div>
      )}

      {energiaEletrica && (
        <div className={styles.smallPiegraph}>
          <SmallPieGraph
            data={energiaEletrica}
            text="ENERGIA ELÉTRICA"
            onLegendClick={onEnergiaEletricaClick}
            currentValue={energiaEletricaValue}
            oldValue={energiaEletricaOldValue}
            onOldValue={onEnergiaEletricaOldValue}
            onImageReady={setEnergiaImage}
          />
        </div>
      )}

      {abastecimentoAgua && (
        <div className={styles.smallPiegraph}>
          <SmallPieGraph
            data={abastecimentoAgua}
            text="ABASTECIMENTO DE ÁGUA"
            onLegendClick={onAbastecimentoAguaClick}
            currentValue={abastecimentoAguaValue}
            oldValue={abastecimentoAguaOldValue}
            onOldValue={onAbastecimentoAguaOldValue}
            onImageReady={setAguaImage}
          />
        </div>
      )}
    </div>
  );
}

export default GeneralConditionL1
